import { StateType } from '../../types';

const ratingSelector = (slice: string, sliver: string) => (state: StateType, id: string) =>
  state[slice][sliver].rating.ratings[id];

export default ratingSelector;
